var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("styled-components")) : "function" == typeof define && define.amd ? define(["styled-components"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.reactFigstrap = t(require("styled-components")) : e.reactFigstrap = t(e["styled-components"]);
}(self, function (e) {
  return function () {
    "use strict";

    var t = {
      608: function _(t) {
        t.exports = e;
      }
    },
        o = {};

    function r(e) {
      var n = o[e];
      if (void 0 !== n) return n.exports;
      var i = o[e] = {
        exports: {}
      };
      return t[e](i, i.exports, r), i.exports;
    }

    r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var o in t) {
        r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
          enumerable: !0,
          get: t[o]
        });
      }
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return function () {
      r.r(n), r.d(n, {
        Frame: function Frame() {
          return t;
        }
      });
      var e = r(608);
      var t = r.n(e)().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n  box-sizing: border-box;\n  gap: ", ";\n  padding: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n"])), function (t) {
        if (t.vertical) return e.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        flex-direction: column;\n      "])));
      }, function (e) {
        return "".concat(e.gap ? e.gap : "0", "px");
      }, function (e) {
        return "".concat(e.padding ? e.padding : "0", "px");
      }, function (e) {
        return "".concat(e.alignItems ? e.alignItems : "stretch");
      }, function (e) {
        return "".concat(e.justifyContent ? e.justifyContent : "flex-start");
      });
    }(), n;
  }();
});